import { createSignal, mergeProps, onMount, useContext } from 'solid-js';
import { AppContext } from '../../../../../../app-context-provider/app-context-provider';
import { Heading } from '../../../../../../ui-components/heading/heading';
import { ImageSrcData, getBackgroundImageSrcData } from '../../../../../image-component/image-component';
import { Quote } from '../../../../../../ui-components/quote/quote';
import { SpacerPdf } from '../spacer/spacer-pdf';

const defaultProps = {};

export const TestimonyPdf = (componentProps: any) => {
    const props = mergeProps(defaultProps, componentProps);
    const { imagesServiceUrl, supportedImageFormats } = useContext(AppContext);
    const [backgroundImageSrcData, setBackgroundImageSrcData] = createSignal<ImageSrcData>();

    onMount(() => {
        if (props.src) {
            const backgroundImage: ImageSrcData = getBackgroundImageSrcData({
                imagesServiceUrl,
                supportedImageFormats,
                src: props.src,
                width: 500,
                height: 'AUTO',
            });

            setBackgroundImageSrcData(backgroundImage);
        }
    });

    return (
        <div>
            <SpacerPdf height={2.5} />
            <div>
                <div class="mb-[0.6rem]">
                    <Heading tag="h3" variant="smallPDF">
                        {props.eyebrowHeading}
                    </Heading>
                    <Heading tag="h2" variant="mediumPDF">
                        {props.testimonyHeading}
                    </Heading>
                </div>
                <div class="flex w-full">
                    <div class="relative w-[27%] pb-[27%] rounded-half bg-[lightblue] self-center overflow-hidden">
                        <img
                            class="absolute w-full h-full top-0 left-0 object-cover object-center"
                            src={backgroundImageSrcData()?.original}
                            alt={props.altText || ''}
                        />
                    </div>

                    <div class="flex flex-1 flex-col justify-end pl-4">
                        <Quote forPdfBuilder={true}>
                            {props.quote.children}
                        </Quote>
                        <p class="font-normal font-atos-regular text-[1.1rem] leading-[1.7rem] tracking-[0] text-black m-0">
                            <span class="font-bold">{props.authorName},</span>
                            {props.authorShortDescription}
                        </p>
                    </div>
                </div>
            </div>
            <SpacerPdf height={2.5} />
        </div>
    );
};

TestimonyPdf.parseProps = (atts: any) => {
    const { image, quote } = atts;

    const commonAtts = {
        eyebrowHeading: atts.eyebrowHeading,
        testimonyHeading: atts.testimonyHeading,
        authorName: atts.authorName,
        authorShortDescription: atts.authorShortDescription,
        quote: quote[0],
    };

    if (image) {
        return {
            src: image.url,
            width: image.width,
            focus: image.focus,
            altText: image?.altText,
            title: image?.title,
            ...commonAtts,
        };
    } else return commonAtts;
};
